import { p as proxyCustomElement, H, h, c as Host } from './p-Dm99HnvB.js';
import { r as removeSSRSlot } from './p-DorpicPE.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.5.0
 */

let sidenavSectionId = 0;
const SidenavSection = /*@__PURE__*/ proxyCustomElement(class SidenavSection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.componentId = `sidenav-section-header-${sidenavSectionId++}`;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '6180a3b3e7cc275db1cca6543e8e6baa0cd1194d', class: "tds-sidenav-section" }, this.label && (h("div", { key: 'e7d059ef4767a21d1b9151072f609b61f0604c0f', class: "tds-sidenav-section-header" }, h("h2", { key: '11f8ae4bf17b4dc1e3e35f0001b55ad627c71f89', id: `${this.componentId}` }, this.label), h("slot", { key: '7f48319f4dc7d6df825a886bec352a17f906ef62', name: "label-actions" }))), h("ul", { key: '09a6e50b878ffefb38bb002dc220934eccc43065', class: "tds-sidenav-section-list", "aria-labelledby": this.label ? `${this.componentId}` : undefined }, h("slot", { key: '609dd29d6fa5799b5db11bfcb4dd3bccca499511' })), h("slot", { key: '7c6ead1b19894d59cbc4b860cc322f3fc23e12b9', name: "section-actions" })));
    }
    get el() { return this; }
}, [6, "tds-sidenav-section", {
        "label": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-section"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavSection);
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav-section.js.map
